import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';

const DirectDebitQuestion = ({ fields }) => (
  <div>
    <p>DirectDebitQuestion Component</p>
    <Text field={fields.heading} />
  </div>
);

export default DirectDebitQuestion;
